import * as React from 'react';
import { Component } from 'react';
import { observer, inject } from 'mobx-react';
import styled, { withTheme } from 'styled-components';
import { propStyles } from '@kurtosys/ksys-portal-components/build/utils/propStyles';
import formatter from "./formatter";
import BarChart from 'recharts/es6/chart/BarChart';
import Bar from 'recharts/es6/cartesian/Bar';
import XAxis from 'recharts/es6/cartesian/XAxis';
import YAxis from 'recharts/es6/cartesian/YAxis';
import CartesianGrid from 'recharts/es6/cartesian/CartesianGrid';
import ResponsiveContainer from 'recharts/es6/component/ResponsiveContainer';
import Tooltip from 'recharts/es6/component/Tooltip';
import Legend from 'recharts/es6/component/Legend';
import VerticalBarLabel from './VerticalBarLabel';

const ResponsiveChartContainer = styled<any, any>(ResponsiveContainer)`
    ${propStyles};
`;

ResponsiveChartContainer.defaultProps = {
    fontSize: "xs"
};

@inject('dataStore')
@observer
class ChartBarChart extends Component<any, any> {
    render() {
        const {
            theme,
            dataStore,
            config,
            data,
            xAxis,
            yAxis,
            layout,
            minHeight,
            aspect,
            series,
            getThemeColor,
            getLabelName,
            getSeriesName,
            locale,
            fundCurrency,
            isMobile
        } = this.props;

        return (
            <ResponsiveChartContainer
                aspect={aspect}
                minHeight={minHeight}
                {...theme.ResponsiveChartContainer}
            >
                <BarChart
                    data={data}
                    layout={layout}
                    margin={layout === "vertical" ? { top: 5, right: 30, bottom: 5, left: 0 } : {}}
                >
                    {
                        config.grid &&
                        <CartesianGrid
                            {...config.grid}
                            stroke={getThemeColor(config.grid.stroke)}
                            fill={getThemeColor(config.grid.fill)}
                        />
                    }
                    {
                        !isMobile && config.tooltip &&
                        <Tooltip
                            cursor={false}
                            {...config.tooltip}
                            labelFormatter={v =>
                                config.tooltip.labelFormat
                                    ? formatter(
                                        config.tooltip.labelFormat.type,
                                        locale,
                                        fundCurrency,
                                        config.tooltip.labelFormat.options,
                                        v
                                    )
                                    : v
                            }
                            formatter={v =>
                                config.tooltip.valueFormat
                                    ? formatter(
                                        config.tooltip.valueFormat.type,
                                        locale,
                                        fundCurrency,
                                        config.tooltip.valueFormat.options,
                                        v
                                    )
                                    : v
                            }
                        />
                    }
                    {
                        config.legend &&
                        <Legend
                            iconType="circle"
                            wrapperStyle={{ bottom: 0 }}
                            {...config.legend}
                        />
                    }
                    {
                        xAxis &&
                        <XAxis
                            dataKey={xAxis.dataKey}
                            tickLine={false}
                            padding={{ left: 10, right: 10 }}
                            {...xAxis}
                            label={{ ...getLabelName(xAxis.label), ...{ offset: 0, angle: 0, position: "insideBottom" } }}
                            tickFormatter={v => xAxis.format ? formatter(
                                xAxis.format.type,
                                locale,
                                fundCurrency,
                                xAxis.format.options,
                                v) : v}
                        />
                    }
                    {
                        yAxis &&
                        <YAxis
                            dataKey={yAxis.dataKey}
                            yAxisId="left"
                            orientation="left"
                            axisLine={false}
                            tickLine={false}
                            {...yAxis}
                            label={getLabelName(yAxis.label)}
                            tickFormatter={v => yAxis.format ? formatter(
                                yAxis.format.type,
                                locale,
                                fundCurrency,
                                yAxis.format.options,
                                v) : v}
                        />
                    }
                    {
                        series.map((s, index) =>
                            <Bar
                                key={`bar-${s.dataKey}-${index}`}
                                dataKey={s.dataKey}
                                yAxisId="left"
                                {...s}
                                name={getSeriesName(s.name, s.nameProperty)}
                                label={isMobile ? <VerticalBarLabel {...s.label} /> : false}
                                fill={getThemeColor(s.fill)}
                                isAnimationActive={!dataStore.isExpandAll}
                            />
                        )
                    }
                </BarChart>
            </ResponsiveChartContainer>
        );
    }
}

export default withTheme(ChartBarChart) as any;


// WEBPACK FOOTER //
// ./src/Components/ChartBarChart.tsx